export default __webpack_public_path__ + "static/media/pizza-3.06e91a25.jpg";